import { useNavigation } from 'expo-router'
import { useCallback, useState, type ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Candle } from '@/src/elements/candle'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTranslate } from '@/src/lang/useTranslate'

type TPrayProps = {
  onPrayed: VoidFunction
  onAmen: VoidFunction
  isLoading?: boolean
  paused?: boolean
}

export const Pray = ({ onPrayed, onAmen, isLoading, paused }: TPrayProps): ReactNode => {
  const [isAmenClicked, setIsAmenClicked] = useState(false)
  const [isPraying, setIsPraying] = useState(true)
  const { t } = useTranslate()

  const isFocused = useNavigation().isFocused()

  const handleCandleFinish = useCallback(() => {
    setIsPraying(false)
    onPrayed()
  }, [onPrayed])

  const handleAmen = () => {
    setIsAmenClicked(true)
    onAmen()
  }

  return (
    <>
      <View className="mx-auto max-w-screen-md grow flex-col justify-center py-4">
        <View className="w-full items-center self-center">
          <Candle
            onFinish={handleCandleFinish}
            enabled={isFocused && !isLoading && !paused}
            className="bg-primary-bg-light"
          />
        </View>
      </View>
      <View className="mb-8 pb-6">
        <Button
          testID={TEST_ID.PRAY.SCREEN.AMEN_BUTTON}
          variant="solid"
          colors="primary"
          isDisabled={isPraying || isLoading || isAmenClicked}
          onPress={handleAmen}
        >
          {t('pray.amen')}
        </Button>
      </View>
    </>
  )
}
